import {
  TypeListRequest,
  TypeListResponse,
  FaultSubmitRequest,
  FaultSubmitResponse,
  BikeInfoRequest,
  BikeInfoResponse,
  IFaultQueryReqV1,
  IFaultQueryResV1,
  IFaultSubmitReqV1,
  IFaultQueryProgressReq,
  FaultReportRecordsReq,
  FaultReportRecordsRes,
} from '@/interface/services/faultReport';
import request from '../utils/request';
import appConst from '../const/app.const';
import { IFaultQueryProgressRes } from '@/pages/fault-report-records/type';
export default class {
  /*
   * @description 车辆故障类型-固定的
   * @yapi https://yapi.hellobike.cn/project/42/interface/api/36042
   * */
  static fixedTypeList(params: TypeListRequest): Promise<TypeListResponse> {
    return request.post(
      {
        action: 'user.ev.fault.fixedTypeList',
        ...params,
      },
      {
        apiServer: appConst.EBIKE_API,
      },
      true,
    );
  }

  /**
   * @description 骑行故障上报接口
   * @yapi https://yapi.hellobike.cn/project/42/interface/api/107610
   */
  static faultSubmit(params: FaultSubmitRequest): Promise<FaultSubmitResponse> {
    return request.post(
      {
        action: 'user.ev.ride.normal.fault.submit',
        ...params,
      },
      {
        apiServer: appConst.EBIKE_API,
      },
      true,
    );
  }

  /**
   * @description 查询车辆信息
   * @yapi https://yapi.hellobike.cn/project/40/interface/api/893
   */
  static getBikeInfo(params: BikeInfoRequest): Promise<BikeInfoResponse> {
    return request.post(
      {
        action: 'user.ride.bikeInfo',
        ...params,
      },
      {
        apiServer: appConst.BIKE_API,
      },
      true,
    );
  }
}

/**
 * @description 用户报障页查询故障配置
 * @yapi https://yapi.hellobike.cn/project/4961/interface/api/356734
 */
export function queryFaultV2(
  params: IFaultQueryReqV1,
): Promise<IFaultQueryResV1> {
  return request
    .post(
      {
        action: 'user.tw.fault.query',
        ...(params || {}),
      },
      {
        apiServer: appConst.EBIKE_API,
      },
      true,
      false,
      false,
      true
    )
    .catch(() => null);
}
export function submitFaultV2(
  params: IFaultSubmitReqV1,
): Promise<{ faultTicketGuid: string; reportId: string }> {
  return request.post(
    {
      action: 'user.tw.fault.report',
      ...(params || {}),
    },
    {
      apiServer: appConst.EBIKE_API,
    },
    true,
    false,
    false,
    true
  );
}

/**
 * @description 查询故障进度
 * @yapi https://yapi.hellobike.cn/project/4961/interface/api/356745
 */
export function queryFaultProgress(
  params: IFaultQueryProgressReq,
): Promise<IFaultQueryProgressRes> {
  return request.post(
    {
      action: 'user.tw.fault.queryProgress',
      ...(params || {}),
    },
    {
      apiServer: appConst.EBIKE_API,
    },
    true,
    false,
    false,
    true
  );
}
/**
 * @description 故障上报记录页
 * @yapi https://yapi.hellobike.cn/project/4961/interface/api/383450
 */
export function getFaultReportRecords(
  params?: FaultReportRecordsReq,
): Promise<FaultReportRecordsRes> {
  return request.post(
    {
      action: 'user.tw.fault.report.records',
      ...(params || { pageNo: 1, pageSize: 10 }),
    },
    {
      apiServer: appConst.EBIKE_API,
    },
    true,
    false,
    false,
    true
  );
}
